import { mapGetters } from 'vuex';

//* Test setup to use apex web cookie token to log user into Connect portal
// import router from '../router';
// import store from '@/store/index';
// import { authTokenCheck } from '@/utils/helpers';

// function getCookie(name) {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop().split(';').shift();
// }

export default {
  data() {
    return {
      v3Me: {},
      me: {
        activated: true,
        bio: '',
        clubhouseHandicaps: [],
        countryAlpha3: '',
        displayName: '',
        email: '',
        gender: '',
        handedness: '',
        handicap: '',
        href: '',
        id: '',
        preferences: {},
        profileImage: {},
        quickStats: {
          averageDriveDistance: 0,
          averagePuttDistance: 0,
          bestDriveDistance: 0,
          bestPuttDistance: 0,
          drivingAccuracy: 0,
          greenInRegulation: 0,
          holesPlayed: 0,
          shotCount: 0,
        },
      },
      // me: {
      //   bio: '',
      //   displayName: '',
      //   quickStats: {
      //     bestDriveDistance: 0,
      //   },
      // },
      // memberships: [
      //   {
      //     id: 1,
      //     text: 'E6Golf',
      //     type: 'clubhouseOwner',
      //     imageURL: 'http://www.lionsclubs.org/cs-assets/_files/images/logos/lionlogo_2c.gif',
      //   },
      // ],
    };
  },

  /**
   * Call the /me endpoint when the
   * component has been mounted
   */
  mounted() {
    //* Test setup to use apex web cookie token to log user into Connect portal
    // const apexCookie = getCookie('apexCookie');
    // if (apexCookie && !localStorage.token) {
    //   localStorage.setItem('token', apexCookie);
    //   authTokenCheck(store, router);
    //   return;
    // }

    if (localStorage?.token !== undefined) {
      this.$store
        .dispatch('users/me')
        .then((res) => {
          this.me = res;
          this.getMe ? (this.me = this.getMe) : null;
          this.$vuetify.theme.dark = this.isDarkMode ?? false;
          localStorage.setItem(
            'userPreferences',
            JSON.stringify({
              userID: res?.id,
              preferences: {
                darkMode:
                  this.getMe?.preferences || this.isDarkMode
                    ? this.getMe?.preferences?.darkMode
                    : false,
              },
            })
          );
        })
        .catch((err) => {
          if (err.status >= 400 || !!err) {
            const alerted = localStorage.getItem('logoutAlert') || '';
            if (alerted !== 'yes') {
              let errorMessage = err?.data?.detail;
              const errorCode = err?.data?.code ?? 'GEN';

              if (!errorMessage) {
                errorMessage = `There was a problem retrieving your account details.`;
              }
              if (errorMessage.toLowerCase().includes('checkusertoken')) {
                errorMessage = `${errorCode}: You are being logged out to prevent unexpected behavior. Please log back in.`;
              }
              // alert(`${errorMessage} You are being logged out. Please log back in.`);
              alert(`${errorMessage}`);
              localStorage.setItem('logoutAlert', 'yes');
            }

            localStorage.removeItem('userPreferences');
            this.$store.dispatch('authentication/logout');
            this.$store.dispatch('users/resetState');
            this.$router.go('/login');
          }
          console.log(err);
        });

      this.$store.dispatch('users/v3Me').then((res) => {
        this.getMeV3 ? (this.v3Me = this.getMeV3) : null;
        if (res?.apex_preferences) {
          this.getMe.apex_preferences = res?.apex_preferences ?? {};
        }
      });
    } else {
      localStorage.removeItem('userPreferences');
    }
  },

  computed: {
    ...mapGetters('users', [
      'getMe',
      'getMeV3',
      'emailSent',
      'sendingEmail',
      'isLoadingUser',
      'isDarkMode',
    ]),

    meV3SetPass() {
      return this.getMeV3?.set_password === 'active';
    },

    meHasPhoneNumber() {
      return !!this.getMe?.phoneNumber;
    },

    // darkMode() {
    //   if (this.me?.preferences) {
    //     return this.me?.preferences?.darkMode;
    //   }
    // },
  },
};
